/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_HomeInputs */

const en_for_whom_tag_home = /** @type {(inputs: For_Whom_Tag_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home exercises`)
};

const pl_for_whom_tag_home = /** @type {(inputs: For_Whom_Tag_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenia do domu`)
};

/**
* | output |
* | --- |
* | "Home exercises" |
*
* @param {For_Whom_Tag_HomeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_home = /** @type {((inputs?: For_Whom_Tag_HomeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_HomeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_home(inputs)
	return en_for_whom_tag_home(inputs)
});